<template>
  <v-dialog v-model="loading" persistent width="300">
    <v-card color="primary" dark>
      <v-card-text>
        Kérem várjon...
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0 mt-1"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Loading",
  computed: {
    ...mapGetters("Axios", ["loading"])
  }
};
</script>

<style></style>
